// Plik: frontend/src/pages/ThankYouPage.js
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Container, Typography, Box, Paper, Button, CircularProgress } from '@mui/material';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import { settingsService } from '../services/api';

const ThankYouPage = () => {
  const navigate = useNavigate();
  const [settings, setSettings] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchSettings = async () => {
      const response = await settingsService.getSettings();
      if (response.success) {
        setSettings(response.data);
      }
      setLoading(false);
    };
    fetchSettings();
  }, []);
  
  // Opcjonalnie: Przekieruj po 30 sekundach
  useEffect(() => {
    const timer = setTimeout(() => {
      navigate('/');
    }, 30000);
    
    return () => clearTimeout(timer);
  }, [navigate]);

  if (loading) {
    return (
      <Container maxWidth="md">
        <Box sx={{ display: 'flex', justifyContent: 'center', py: 8 }}>
          <CircularProgress />
        </Box>
      </Container>
    );
  }

  return (
    <Container maxWidth="md">
      <Box sx={{ my: 8, textAlign: 'center' }}>
        <CheckCircleOutlineIcon 
          sx={{ 
            fontSize: 80, 
            color: 'success.main',
            mb: 2
          }} 
        />
        
        <Typography variant="h3" component="h1" gutterBottom>
          {settings?.thankyou_title || 'Dziękujemy za rejestrację!'}
        </Typography>
        
        <Paper elevation={3} sx={{ p: 4, my: 4 }}>
          <Typography variant="h6" gutterBottom>
            {settings?.thankyou_subtitle || 'Twoje zgłoszenie zostało przyjęte pomyślnie'}
          </Typography>
          
          <Typography variant="body1" paragraph>
            {settings?.thankyou_message_1 || 'Na podany adres e-mail zostało wysłane potwierdzenie rejestracji z wszystkimi szczegółami dotyczącymi Twojej wizyty.'}
          </Typography>
          
          <Typography variant="body1" paragraph>
            {settings?.thankyou_message_2 || 'Prosimy o sprawdzenie skrzynki odbiorczej (a także folderu SPAM) i zapoznanie się z informacjami.'}
          </Typography>
          
          <Typography variant="body1" paragraph>
            {settings?.thankyou_message_3 || 'W przypadku pytań lub potrzeby zmiany terminu, prosimy o kontakt.'}
          </Typography>
        </Paper>
        
        <Button 
          variant="contained" 
          color="primary"
          size="large"
          onClick={() => navigate('/')}
          sx={{ mt: 2 }}
        >
          Powrót do strony głównej
        </Button>
      </Box>
    </Container>
  );
};

export default ThankYouPage;